/**
 * Utility service to send form notification emails to:
 * 1. globaleprc@gmail.com
 * 2. jebincocjebnjebin232@gmail.com
 */

const RECIPIENT_EMAILS = [
  'globaleprc@gmail.com',
  'jebincocjebnjebin232@gmail.com'
];

export const sendNotificationEmail = async ({ formType, subject, data }) => {
  const payload = {
    _subject: subject || `New ${formType} Submission - GEPRC`,
    _template: 'table',
    _captcha: 'false',
    _cc: RECIPIENT_EMAILS[1], // CC the second email
    Form_Type: formType,
    Submitted_At: new Date().toLocaleString(),
    ...data,
  };

  // If resume base64 is present, do not bloat email payload
  if (payload.resume && typeof payload.resume === 'string' && payload.resume.startsWith('data:')) {
    payload.resume_attachment = '[Stored in Firebase Database & Admin Panel]';
    delete payload.resume;
  }

  // Attempt sending to primary recipient with CC
  try {
    const response = await fetch(`https://formsubmit.co/ajax/${RECIPIENT_EMAILS[0]}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    // Also send directly to second email as backup to guarantee receipt
    fetch(`https://formsubmit.co/ajax/${RECIPIENT_EMAILS[1]}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(payload),
    }).catch((err) => console.warn('Backup email delivery notice:', err));

    const result = await response.json();
    return { success: true, result };
  } catch (error) {
    console.warn('Failed to dispatch notification email:', error);
    return { success: false, error };
  }
};
